export default {"src":"/_next/static/media/PARA.97851d1c.svg","height":18,"width":18};